import AppState from '../app-state';
import { OrderedMap } from 'immutable';
import type { ReduxAction } from '@repo/utils/types';

type LocationString = string;

export interface ContactLocation {
  latitude: number;
  longitude: number;
  location: string;
  timezone: string;
}

export type LocationsState = OrderedMap<LocationString, ContactLocation>;

const initialLocationsState = OrderedMap<LocationString, ContactLocation>();

export const selectLocation = (contactLocation: string) => (state: AppState) => {
  return state.data.locations.get(contactLocation);
};

export function locationsReducer(
  state: LocationsState = initialLocationsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_LOCATION_SUCCEEDED':
      return state.set(payload.location, payload.response);

    default:
      return state;
  }
}
